export default __webpack_public_path__ + "static/media/pictogramBeaconShortcuts64.3e74cfd3.svg";